import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectorRef,
  OnChanges, AfterViewChecked
} from '@angular/core';
import { FormBuilder, FormControl, Validators, AbstractControl, FormGroup, FormArray } from '@angular/forms';
import { SDTKService } from '../../sdtk.service';
import { SDTK } from '../../../../model/quote/sdtk/sdtk.model';
import { QuoteService } from '../../../quote.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocalStorageService } from 'ngx-webstorage';
import { environment } from '../../../../../environments/environment';
import { formatDate } from '@angular/common';
import { PolicyService } from '../../../../policy/policy.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-sdtk-proposer-details',
  templateUrl: './sdtk-proposer-details.component.html',
  styleUrls: ['./sdtk-proposer-details.component.css', '../../../quote.component.css']
})
export class SdtkProposerDetailsComponent implements OnInit, OnDestroy {

  addresses;
  formFields: any;
  private postcodeLookupSubject = new Subject<string>();
  private postcodeLookupSubscription: Subscription;
  submitted = false;
  isBroker = false;
  brokers: any = [];
  showContactDetails = false;
  UK_HB_INSURANCE_COMPANY_ID = '';
  quote_type: number = this.route.snapshot.params.quote_type ? this.route.snapshot.params.quote_type : 1;
  ratingType: any;

  // Dates
  isEffectiveDatePast = false;
  currDate = new Date();
  minEffectiveDate = new Date();
  minInceptionDate = new Date();
  maxInceptionDate = new Date();
  maxDob: any = new Date();
  reasons = [];
  policyReasons;

  // Input Decorators
  @Input() staticData;
  @Input() authDetails;
  @Input() apiModelObject;

  modelObject = new SDTK();

  // Output Decorators
  @Output() modelObjectUpdated = new EventEmitter<SDTK>();
  policyEndDateMax: Date = new Date();
  @Output() isFleetActivated = new EventEmitter<boolean>();

  constructor(
    private formBuilder: FormBuilder,
    private sdtkService: SDTKService,
    private quoteService: QuoteService,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private sessionState: LocalStorageService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private policyService: PolicyService
  ) { }

  ngOnInit(): void {
    this.getBrokers();
    if (this.quote_type == 4) {
      this.fetchMTAFinancials();

    }

    this.formFields = this.formBuilder.group({
      inception_date: ['', Validators.required],
      cover_to: ['', Validators.required],
      company_id: ['', Validators.required],
      effective_date: ['', Validators.required],
      mta_reason_id: ['', Validators.required],
      other_reason: [''],
      proposer: this.proposerDetails(),
      // rating_type: ['', Validators.required],
      vehicles: this.formBuilder.array([])
    });

    const maxDate = new Date().setDate(new Date().getDate() + 30);
    this.maxInceptionDate = new Date(maxDate);

    const currentDate = new Date();
    currentDate.setFullYear(new Date().getFullYear() - 18);
    this.maxDob = currentDate.toISOString().slice(0, 10);

    if (this.quote_type && this.quote_type != 3) {
      this.formFields.get('effective_date').disable();
    } else {
      this.formFields.get('effective_date').enable();
    }

    if ((this.quote_type) && (this.quote_type == 3 || this.quote_type == 4)) {
      this.formFields.get('effective_date').enable();
      if (this.quote_type == 3) {
        //this.formFields.get('other_reason').enable();
      }
      else {
        this.formFields.get('other_reason').disable();
      }
      this.formFields.get('mta_reason_id').enable();
      this.formFields.get('inception_date').disable();
      this.formFields.get('cover_to').disable();
    } else {
      this.formFields.get('effective_date').disable();
      this.formFields.get('inception_date').enable();
      this.formFields.get('cover_to').enable();
      this.formFields.get('mta_reason_id').disable();
      this.formFields.get('other_reason').disable();
    }
    // if (this.quote_type && this.quote_type == 4) {
    //   this.formFields.get('effective_date').enable();
    //   this.formFields.get('cover_to').disable();
    //   this.formFields.get('inception_date').disable();
    // }
    // else {
    //   this.formFields.get('cover_to').enable();
    //   this.formFields.get('inception_date').enable();
    // }
    if (this.sessionState.retrieve('is_broker')) {
      this.isBroker = true;
      this.formFields.get('company_id').setValue(this.sessionState.retrieve('broker_company_id'));
    }
    // GET POLICY MTA REASONS
    if (this.route.snapshot.params.quote_type) {
      this.getPolicyReasons(this.route.snapshot.params.quote_type);
    }


    // Subscribe to mta_reason_id changes
    this.formFields.get('mta_reason_id').valueChanges.subscribe(value => {
      const otherReasonControl = this.formFields.get('other_reason');

      if (value === '1' && this.quote_type == 3) {
        // Enable validation when "Other" is selected
        otherReasonControl.setValidators([Validators.required]);
      } else {
        // Remove validation and clear the field
        otherReasonControl.clearValidators();
        otherReasonControl.setValue('');
      }

      // Update the validity status
      otherReasonControl.updateValueAndValidity();
    });

    this.postcodeLookupSubscription = this.postcodeLookupSubject.pipe(debounceTime(400)).subscribe((postcode) => {
      this.doPostcodeLookup(postcode);
    });
  }

  ngOnDestroy() {
    if (this.postcodeLookupSubscription) {
      this.postcodeLookupSubscription.unsubscribe();
    }
  }

  proposerDetails() {
    return this.formBuilder.group({
      address: this.proposerAddress(),

      title: ['', Validators.required],
      first_name: ['', Validators.required],
      last_name: [''],
      dob: ['', Validators.required],
      email: ['', Validators.email],
      phone: [''],
      is_email: [0],
      is_phone: [0],
      sms: [0],
      post: [0],
    });
  }
  proposerAddress() {
    return this.formBuilder.group({
      line1: ['', Validators.required],
      line2: [''],
      line3: [''],
      county: ['', Validators.required],
      postcode: ['', Validators.required]
    });
  }
  get proposerAddressControls() {
    return ((this.proposerControls.address as FormGroup).controls);
  }
  get proposerControls() {
    return ((this.formFields.get('proposer') as FormGroup).controls);
  }
  initVehicles() {
    return this.formBuilder.group({
      registration_number: ['', Validators.required],
      make: ['', Validators.required],
      model: ['', Validators.required],
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.apiModelObject) {
      this.modelObject = this.mapApiToSDTK(this.apiModelObject);

      const inception_date = new Date(this.modelObject.inception_date);
      const effectiveDate = new Date(this.modelObject.effectiveDate);
      const curr_date = new Date();
      // if (this.apiModelObj.type == 1 && inception_date > curr_date) {
      //   this.minInceptionDate = new Date();
      // } else {
      //   this.minInceptionDate = new Date(this.modelObject.inception_date);
      // }
      if (this.apiModelObject.type == 3) {
        //this.quote_type = 3;
        if (effectiveDate < curr_date) {
          this.isEffectiveDatePast = true;
          this.minEffectiveDate = new Date();
        } else {
          this.isEffectiveDatePast = false;
        }
      }
      if (this.quote_type == 3) {
        if (effectiveDate < curr_date) {
          this.isEffectiveDatePast = true;
          this.minEffectiveDate = new Date();
        } else {
          this.isEffectiveDatePast = false;
        }
      }
      if (this.apiModelObject.is_send_email === 1) {
        this.showContactDetails = true;
      }

      this.showContactDetails = true;
      this.patchValues();
    }
    if (this.quote_type == 4) {
      this.fetchMTAFinancials();

    }
  }
  onPolicyStartDateChange(event) {
    this.setCoverToDate(event.value);
  }


  setCoverToDate(value) {
    const maxDate = new Date(value).setFullYear(new Date(value).getFullYear() + 1);
    this.policyEndDateMax = new Date(new Date(maxDate).getTime() - (24 * 60 * 60 * 1000));
    this.formFields.get('cover_to').setValue(this.policyEndDateMax);
  }
  /** Called when user selects an address. Supports backend (id + getAddressById) and legacy full object. */
  onSelectAddress(record: any) {
    if (!record) return;
    const currentPostcode = this.proposerAddressControls.postcode.value;
    if (record.id != null && record.id !== '') {
      this.quoteService.getAddressById(record.id).subscribe({
        next: (full: any) => {
          this.applyAddressToForm(full);
          setTimeout(() => {
            if (this.proposerAddressControls.postcode.value !== currentPostcode) {
              this.proposerAddressControls.postcode.setValue(currentPostcode);
            }
          }, 0);
        },
        error: () => {}
      });
      return;
    }
    this.applyAddressToForm(record);
    setTimeout(() => {
      if (this.proposerAddressControls.postcode.value !== currentPostcode) {
        this.proposerAddressControls.postcode.setValue(currentPostcode);
      }
    }, 0);
  }

  private applyAddressToForm(address: any) {
    if (!address || !this.proposerAddressControls) return;
    const a = address;
    const line1 = a.line1 ?? a.Line1 ?? a.line_1 ?? a.address_1 ?? (a.formatted_address && a.formatted_address[0]) ?? '';
    const line2 = a.line2 ?? a.Line2 ?? a.line_2 ?? a.address_2 ?? (a.formatted_address && a.formatted_address[1]) ?? '';
    const line3 = a.town ?? a.Town ?? a.town_or_city ?? a.line3 ?? a.line_3 ?? (a.formatted_address && a.formatted_address[2]) ?? '';
    const county = a.county ?? a.County ?? (a.formatted_address && a.formatted_address[3]) ?? '';
    const postcode = a.postcode ?? a.Postcode ?? '';
    this.proposerAddressControls.line1.setValue(line1 || '');
    this.proposerAddressControls.line2.setValue(line2 || '');
    this.proposerAddressControls.line3.setValue(line3 || '');
    this.proposerAddressControls.county.setValue(county || '');
    if (postcode) this.proposerAddressControls.postcode.setValue(postcode);
  }

  postcodeLookup(event: any) {
    const postcode = (event?.target?.value || '').trim();
    if (!postcode || postcode.length < 4) {
      this.addresses = [];
      return;
    }
    this.postcodeLookupSubject.next(postcode);
  }

  private doPostcodeLookup(postcode: string) {
    const trimmed = (postcode || '').trim();
    if (!trimmed || trimmed.length < 4) {
      this.addresses = [];
      return;
    }
    this.quoteService.getAddress(trimmed).subscribe({
      next: (response: any) => {
        const records = response?.records || response?.addresses || [];
        this.addresses = Array.isArray(records) ? records : [];
      },
      error: () => { this.addresses = []; }
    });
  }
  get f(): { [key: string]: AbstractControl } {
    if (this.formFields) {
      return this.formFields.controls;
    }
  }
  patchValues() {
    // var effective_date = (new Date(this.modelObject.inception_date) < new Date()) ? new Date() : this.modelObject.inception_date;
    let effectiveDate = this.isEffectiveDatePast ? new Date(this.minEffectiveDate) : this.modelObject.inception_date;
    if (this.modelObject.effectiveDate) {
      effectiveDate = new Date(this.modelObject.effectiveDate);
    }
    const isNewMTA = this.route.snapshot.params.quote_type == 3 && this.modelObject.id === this.route.snapshot.params.id;
    this.formFields.patchValue({
      inception_date: this.modelObject.inception_date,
      company_id: this.modelObject.company_id,
      proposer: this.modelObject.proposer,
      // rating_type: this.modelObject.ratingType,
      effective_date: effectiveDate,
      mta_reason_id: isNewMTA ? '':this.modelObject.mta_reason_id,
      other_reason: isNewMTA ? '':this.modelObject.mta_reason_other
    });

    if (this.sessionState.retrieve('is_broker')) {
      this.formFields.get('company_id').setValue(this.sessionState.retrieve('broker_company_id'));
    }

    this.setCoverToDate(this.modelObject.inception_date);
    //this.ratingType(this.modelObject.ratingType);

    if (this.apiModelObject.financial_details) {
      this.modelObject.brokerComission = this.apiModelObject.financial_details.broker_commission;
      this.modelObject.brokerAdminFee = this.apiModelObject.financial_details.broker_admin_fee;
    } else {
      const brokerDetails = this.brokers.filter((x => x.id === this.modelObject.company_id));
      if (brokerDetails.length > 0) {
        this.modelObject.brokerComission = brokerDetails[0].broker_commission;
        this.modelObject.brokerAdminFee = brokerDetails[0].broker_admin_fee;
      }
    }
  }

  public getBrokers() {
    this.quoteService.getBrokers(9) // 'product_type' should be 7, but isn't implemented in the back-end API.
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.brokers = response.result;
          }
        },
        (error) => { }
      );
  }
  public getBrokerCommission(event) {
    const brokerDetails = this.brokers.filter((x => x.id == event.value));
    if (brokerDetails.length > 0) {
      if (brokerDetails[0].is_send_email == 1) {
        this.proposerControls.email?.clearValidators();
        this.proposerControls.phone?.clearValidators();
        this.proposerControls.email?.setValue('');
        this.proposerControls.phone?.setValue('');
        this.proposerControls.is_phone?.setValue(0);
        this.proposerControls.is_email?.setValue(0);
        this.proposerControls.sms?.setValue(0);
        this.proposerControls.post?.setValue(0);

        this.proposerControls.email?.updateValueAndValidity();

        this.proposerControls.phone?.updateValueAndValidity();
      }

      // set comission fees
      this.modelObject.brokerComission = brokerDetails[0].broker_commission;
      this.modelObject.brokerAdminFee = brokerDetails[0].broker_admin_fee;
    }
    this.showContactDetails = true;
  }
  onSubmit() {
    this.submitted = true;

    if (this.quote_type != 3 && !this.modelObject.effectiveDate) {
      this.formFields.get('effective_date')!.disable();
    }

    if (this.formFields.invalid) {
      const firstInvalidControl = document.querySelector('.ng-invalid');
      if (firstInvalidControl) {
        (firstInvalidControl as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'center' });
        (firstInvalidControl as HTMLElement).focus();
      }
      return false;
    }

    const formData = this.formFields.value;

    // if (this.quote_type == 3 || this.quote_type == 4) {
    //   this.modelObject.inception_date = this.modelObject.inception_date;
    // }
    // else {
    //   this.modelObject.inception_date = formatDate(formData.inception_date, 'yyyy-MM-dd', 'en-US');
    // }

    if (this.quote_type == 4) {
      this.modelObject.cover_to = this.modelObject.cover_to;
    }
    else {
      this.modelObject.cover_to = formData.cover_to;
    }
    // this.modelObject.cover_to = formData.cover_to;
    this.modelObject.broker_id = this.sessionState.retrieve('userInfo').id;
    this.modelObject.proposer = formData.proposer;

    if (this.sessionState.retrieve('company_role') == 'Broker') {
      this.modelObject.company_id = this.sessionState.retrieve('broker_company_id');
    } else {
      this.modelObject.company_id = formData.company_id;
    }
    if (this.quote_type == 3 || this.quote_type == 4) {
      this.modelObject.mta_reason_id = formData.mta_reason_id;
      this.modelObject.mta_reason_other = formData.other_reason;
    }



    // FIXED: Only clear vehicles for NEW quotes, not for MTA or existing quotes
    if (!this.route.snapshot.params.id && !this.modelObject.id && this.quote_type != 3) {
      this.modelObject.vehicles = null;
      this.modelObject.fleet_experiences = null;
    }

    if (this.quote_type == 3 || this.quote_type == 4) {
      this.modelObject.inception_date = this.modelObject.inception_date;
    }
    else {
      this.modelObject.inception_date = formatDate(formData.inception_date, 'yyyy-MM-dd', 'en-US');
    }

    if (formData.proposer && formData.proposer.dob) {
      if (formData.proposer.dob) {
        this.modelObject.proposer.dob = formatDate(formData.proposer.dob, 'yyyy-MM-dd', 'en-US');
      }
      if (formData.proposer.licence_length) {
        this.modelObject.proposer.licence_length = formatDate(formData.proposer.licence_length, 'yyyy-MM-dd', 'en-US');
      }
    }

    this.modelObject.declaration = true;

    // Store original ID and preserve vehicle data for MTA
    let originalQuoteId = this.modelObject.id;

    if (this.quote_type == 3) {
      if (this.apiModelObject && this.apiModelObject.id) {
        this.modelObject.policyId = this.apiModelObject.id;
        //this.modelObject.effectiveDate = formatDate(formData.effective_date, 'yyyy-MM-dd', 'en-US');
        this.modelObject.oldPolicyId = originalQuoteId;
        this.modelObject.type = 3;

        let effectiveDate: any = null;

        if (formData?.effective_date) {
          effectiveDate = formData.effective_date;
        } else if (this.modelObject?.effectiveDate) {
          effectiveDate = this.modelObject.effectiveDate;
        } else if (this.apiModelObject?.effectiveDate) {
          effectiveDate = this.apiModelObject.effectiveDate;
        }

        if (effectiveDate) {
          this.modelObject.effectiveDate = formatDate(
            new Date(effectiveDate),
            'yyyy-MM-dd',
            'en-US'
          );
        }

        // Keep vehicles from the original policy
        if (!this.modelObject.vehicles || this.modelObject.vehicles.length === 0) {
          this.modelObject.vehicles = this.apiModelObject.vehicles ?? [];
        }
      }
    }

    if (this.modelObject.type == 2) {
      this.modelObject.policyId = null;
      this.modelObject.effectiveDate = null;
    }

    // Ensure vehicles are properly formatted
    if (this.modelObject.vehicles && this.modelObject.vehicles.length > 0) {
      this.modelObject.vehicles.forEach((res, i) => {
        res.registration_number = (res.registration_number) ? res.registration_number : '';
        res.make = (res.make) ? res.make : '';
        res.model = (res.model) ? res.model : '';
        res.type = (res.type) ? res.type : '';
        res.size = (res.size) ? res.size : '';
        res.colour = (res.colour) ? res.colour : '';
        res.value = (res.value) ? res.value : '';
      });
    }
    const isNewMTA = this.route.snapshot.params.quote_type == 3 && this.modelObject.id === this.route.snapshot.params.id;
    //const isNewMTA = this.quote_type == 3 && !this.route.snapshot.params.id;
    const data = {
      "quote_data": {
        "type": this.quote_type,
        "id": isNewMTA || this.route.snapshot.params.quote_type == 4 ? null : this.modelObject.id,
        "broker_id": this.modelObject.broker_id,
        "company_id": this.modelObject.company_id,
        "sequence_number": this.modelObject.sequenceNumber,
        "policy_start_date": this.modelObject.inception_date,
        "policy_end_date": this.modelObject.cover_to,
        "policy_ref_number": this.modelObject.policyRefNumber,
        "old_policy_id": this.quote_type == 3 ? originalQuoteId : (this.modelObject.oldPolicyId || null),
        "policy_id": this.quote_type == 3 ? this.apiModelObject.id : (this.modelObject.policyId || null),
        "effective_date": this.quote_type == 3 || this.quote_type == 4 ? this.modelObject.effectiveDate : null,

        "quote_meta_id": this.modelObject.quoteMetaId,
        "sdtk_option_id": this.modelObject.sdtk_option_id,
        "policy_holder": {
          "title": this.modelObject.proposer.title,
          "first_name": this.modelObject.proposer.first_name,
          "last_name": this.modelObject.proposer.last_name,
          "email": this.modelObject.proposer.email,
          "phone": this.modelObject.proposer.phone,
          "mobile": this.modelObject.proposer.mobile ? this.modelObject.proposer.mobile : '',
          "dob": this.modelObject.proposer.dob,
          "proposer_type": 1,
        },
        "address": {
          "address1": this.modelObject.proposer.address.line1,
          "address2": this.modelObject.proposer.address.line2,
          "address3": this.modelObject.proposer.address.line3,
          "address4": "",
          "address5": "",
          "city": this.proposerAddressControls.county.value,
          "country": "UK",
          "postcode": this.proposerAddressControls.postcode.value,
        },
        "sms": this.modelObject.proposer.sms,
        "post": this.modelObject.proposer.post,
        "is_phone": this.modelObject.proposer.is_phone,
        "is_email": this.modelObject.proposer.is_email,
        "vehicle_details": this.modelObject.vehicles,
        'send_email': 0,
        'questions': this.modelObject.questions,
        'mta_reason_id': this.quote_type == 3 || this.quote_type == 4 ? this.modelObject.mta_reason_id : null,
        'mta_reason_other': this.quote_type == 3 || this.quote_type == 4 ? this.modelObject.mta_reason_other : null
      }
    };

    this.sdtkService.saveQuote(data)
      .subscribe(
        (res: any) => {
          if (res.success) {
            if (res.result.quote_data) {
              const apiObj = res.result.quote_data.quote_versions[0];
              this.modelObject = this.mapApiToSDTK(apiObj);

              // For MTA, preserve the original policy reference and vehicles
              if (this.quote_type == 3) {
                this.modelObject.policyId = this.apiModelObject.id;
                this.modelObject.oldPolicyId = originalQuoteId;
                this.modelObject.type = 3;
                // Get raw value from the form control (works even if disabled)
                const effectiveDateValue = this.formFields.get('effective_date')?.value;

                // Only format if we have a valid value
                if (effectiveDateValue) {
                  this.modelObject.effectiveDate = formatDate(effectiveDateValue, 'yyyy-MM-dd', 'en-US');
                } else if (this.modelObject.effectiveDate) {
                  // If no form value, ensure the existing value is properly formatted
                  this.modelObject.effectiveDate = formatDate(
                    new Date(this.modelObject.effectiveDate),
                    'yyyy-MM-dd',
                    'en-US'
                  );
                }

                // Ensure vehicles are preserved
                if (!this.modelObject.vehicles || this.modelObject.vehicles.length === 0) {
                  this.modelObject.vehicles = this.apiModelObject.vehicles ?? [];
                }
              }

              if (this.route.snapshot.params.quote_type != 4) {
                this.modelObjectUpdated.emit(this.modelObject);
              }
              else {
                //this.router.navigateByUrl("/policy-list");
                this.router.navigateByUrl('/sdtk/policy/' + res.result.quote_data.quote_versions[0].id);
              }
            }
          } else {
            this._snackBar.open(res.message, '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          }
        });
  }
  private mapApiToSDTK(api: any): SDTK {
    const model = new SDTK();

    model.id = api.id;
    model.sdtk_option_id = api.sdtk_option_id;
    model.type = api.type;
    model.broker_id = api.broker_id;
    model.company_id = api.company_id;
    model.sequenceNumber = api.sequence_number;
    model.policyRefNumber = api.policy_ref_number;
    model.quoteMetaId = api.quote_meta_id;
    model.excess_protect_cover_id = api.excess_protect_cover_id;

    model.inception_date = api.policy_start_date;
    model.cover_to = api.policy_end_date;
    model.effectiveDate = api.effective_date;
    // Add MTA-specific fields
    model.policyId = api.policy_id;
    model.oldPolicyId = api.old_policy_id;

    // proposer
    model.proposer.micro_enterprise = api.policy_holder.is_micro_enterprise;
    model.proposer.first_name = api.policy_holder.first_name;
    model.proposer.last_name = api.policy_holder.last_name;
    model.proposer.title = api.policy_holder.title;
    model.proposer.dob = api.policy_holder.dob;
    model.proposer.email = api.policy_holder.email;
    model.proposer.phone = api.policy_holder.phone;
    model.proposer.is_phone = api.policy_holder.is_phone;
    model.proposer.sms = api.policy_holder.sms;
    model.proposer.post = api.policy_holder.post;
    model.proposer.is_email = api.policy_holder.is_email;
    model.proposer.proposer_type = api.policy_holder.proposer_type;
    model.proposer.micro_enterprise = api.policy_holder.is_micro_enterprise;
    model.proposer.company_name = api.policy_holder.company_name;
    model.proposer.trading_name = api.policy_holder.trading_name;
    model.proposer.year = api.policy_holder.year_of_establishment;
    model.proposer.address.line1 = api.policy_holder.address.address1;
    model.proposer.address.line2 = api.policy_holder.address.address2;
    model.proposer.address.line3 = api.policy_holder.address.address3;
    model.proposer.address.line4 = api.policy_holder.address.address4;
    model.proposer.address.county = api.policy_holder.address.city;
    model.proposer.address.postcode = api.policy_holder.address.postcode;
    model.proposer.address.country = api.policy_holder.address.country;
    model.mta_reason_id = api.mta_reason_id;
    model.mta_reason_other = api.mta_reason_other;

    // Preserve vehicles data
    model.vehicles = api.vehicles ?? [];
    model.questions = api.sdtk_questions;

    // financial details
    if (api.financial_details) {
      model.brokerAdminFee = api.financial_details.broker_admin_fee;
      model.brokerComission = api.financial_details.broker_commission;
    }

    return model;
  }

  /**
   * Calculations For MTA AND CANCELLATION
   */

  showMTACalculation: boolean = false;
  isLoadingMTA: boolean = false;
  onDateChange(newDate: any) {
    this.modelObject.effectiveDate = newDate;
    this.fetchMTAFinancials(); // Will use updated modelObject.effectiveDate
  }
  mtaFinancials: any;
  fetchMTAFinancials(effectiveDate?: string | Date) {
    if (!this.modelObject.id || !this.modelObject.sdtk_option_id) {
      console.warn('Missing required data for MTA calculation');
      this.showMTACalculation = false;
      return;
    }

    this.isLoadingMTA = true;
    this.showMTACalculation = false;

    // Use passed date or fall back to modelObject.effectiveDate or current date
    let dateToUse: string;
    if (effectiveDate) {
      // If it's a Date object, convert to ISO string
      dateToUse = effectiveDate instanceof Date
        ? effectiveDate.toISOString().split('T')[0]
        : effectiveDate;
    } else {
      dateToUse = this.modelObject.effectiveDate || new Date().toISOString().split('T')[0];
    }

    // Prepare request payload
    const mtaRequest = {
      quote_id: this.modelObject.id,
      quote_meta_id: this.modelObject.quoteMetaId,
      previous_policy_id: this.apiModelObject?.id, // ID of the policy being modified
      sdtk_option_id: this.modelObject.sdtk_option_id,
      effective_date: dateToUse,
      type: this.quote_type
    };

    console.log('Fetching MTA Financials:', mtaRequest);

    // Call backend service
    this.sdtkService.getMTACancellationCalculations(mtaRequest)
      .subscribe(
        (response: any) => {
          this.isLoadingMTA = false;

          if (response.success && response.mta_financials) {
            this.mtaFinancials = response.mta_financials;
            this.showMTACalculation = true;

            console.log('MTA Financials received:', this.mtaFinancials);

            console.log('MTA adjustment calculated successfully');
          } else {
            console.warn('No MTA financials in response');
            this.showMTACalculation = false;

            // this._snackBar.open('Unable to calculate MTA adjustment', 'Close', {
            //   duration: 3000,
            //   panelClass: 'warning-snackbar'
            // });
          }
        },
        (error) => {
          this.isLoadingMTA = false;
          this.showMTACalculation = false;

          console.error('Error fetching MTA financials:', error);

          this._snackBar.open('Error calculating MTA adjustment. Please try again.', 'Close', {
            duration: 5000,
            panelClass: 'error-snackbar'
          });
        }
      );
  }
  //capitalize first letter
  capitalizeField(event: Event, fieldName: string): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if (value && value.length > 0) {
      const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);

      const proposerGroup = this.formFields.get('proposer') as FormGroup;
      proposerGroup.get(fieldName)?.setValue(capitalizedValue, { emitEvent: false });
    }
  }


  /*
  * GET POLICY REASONS
  */
  getPolicyReasons(type) {
    this.policyService.getPolicyMTAReasons(environment.SADDLERY_TACK_PROTECT_ID)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.reasons = [];
            response.result.types.forEach((res) => {

              if (res.product_id == environment.SADDLERY_TACK_PROTECT_ID) {
                this.reasons.push(res);
              }
            })

            // Filter by type: MTA (type 3) uses reason type 1, Cancel (type 4) uses reason type 2
            if (type == 3) {
              this.policyReasons = this.reasons.filter(reason => reason.type == 1);
            } else if (type == 4) {
              this.policyReasons = this.reasons.filter(reason => reason.type == 2);
            } else {
              this.policyReasons = this.reasons;
            }
          }
        },
        (error) => {
          ;
        }
      );
  }
}
